function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCombiBoxProperties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1119 -425)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 546",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(1119 425)",
    style: {
      fill: "#ff00b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2745",
    d: "M19.583 13.744a1.05 1.05 0 0 1-.743-.307 4.637 4.637 0 0 0-6.4 0 1.05 1.05 0 0 1-1.485-1.485 6.627 6.627 0 0 1 9.375 0 1.05 1.05 0 0 1-.743 1.792m2.958-2.958a1.055 1.055 0 0 1-.743-.307 8.723 8.723 0 0 0-12.322 0 1.05 1.05 0 0 1-1.489-1.486 10.828 10.828 0 0 1 15.293 0 1.05 1.05 0 0 1-.743 1.792M25.5 7.826a1.051 1.051 0 0 1-.743-.306 12.908 12.908 0 0 0-18.24 0 1.051 1.051 0 0 1-1.486-1.485 15.015 15.015 0 0 1 21.211 0 1.049 1.049 0 0 1-.742 1.791",
    transform: "translate(1121.776 425.824)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2744",
    d: "M7.5 10.5v6l3-3v-3zM0 3l7.5 6h3L18 3zm0-1.5h18V0H0z",
    transform: "translate(1128 441.5)",
    style: {
      fill: "#f5f5f5"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombiBoxProperties);
export default __webpack_public_path__ + "static/media/combi-box-properties.750cf3e148ff0c5e6a1d983ae6c6c48d.svg";
export { ForwardRef as ReactComponent };